import React, { useEffect, useState } from "react";
import { CButton, CCard, CCardBody, CCardText, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormCheck } from '@coreui/react'
import { CBadge, CCardTitle, CFormInput, CFormLabel, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormSelect, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import Select from 'react-select'

import SaveTasks from "../../../services/general/TaskCrud.api";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import CloudinaryUploader from "../../../components/shared/CloudinaryUploader";
import { EllipsisVertical, Pencil, Trash, X } from "lucide-react";
import RegisterUser from "../../../services/general/register.api";
import ImagingInformation from "../../../services/general/ImagingAPI.api";
import MedicineCRUD from "../../../services/general/Medication.api";
import LabCRUD from "../../../services/general/LabsAPI.api";
import UseIsMobile from "../../../components/shared/UseIsMobile";
import CustomDatePickingFormat from '../../../components/shared/CustomDatePickingFormat';
import { formatValueToISODate } from "../../../components/shared/customDateFormatUtils";
import './task-jira-ui.css'

const ProviderUpdateTask = ({ visible, setVisible, fetchBoard, updateTaskId }) => {

    //const { id: boardId } = useParams();

    const [activeKey, setActiveKey] = useState(3);
    const [boardData, setBoardData] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const [subTasks, setSubTasks] = useState('')
    const [subtaskId, setSubTaskId] = useState(null)
    //const [tempActivities, setTempActivities] = useState([])
    const [comment, setComment] = useState('')
    const [commentEditId, setCommentEditId] = useState(null)
    const [selectLabs, setSelectLabs] = useState([])
    const [selectMeds, setSelectMeds] = useState([])
    const [selectImaging, setSelectImaging] = useState([])
    const[prmBoardId,setboardId]=useState(null)
 const [originalTask, setOriginalTask] = useState(null);
    const isMobile = UseIsMobile()
    // set state again
    useEffect(() => {
       if (!updateTaskId) return
        console.log(updateTaskId, 'updatetaskid')
        setTitle(updateTaskId?.title)
        setDescription(updateTaskId?.description)
        setSubTasks(updateTaskId?.subTasks)
        setboardId(updateTaskId?.boardId)
        const now = new Date()
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        setTask((p) => ({
            ...p,
            StatusId: updateTaskId?.statusId,
            Status: updateTaskId?.status,
            subtask: updateTaskId?.subTasks,
            DueDate: updateTaskId?.dueDate,
            Priority: updateTaskId?.priority,
            Tags: updateTaskId?.tags,
            comments: updateTaskId?.comments,
            files: updateTaskId?.files,
            Assignee: { value: updateTaskId?.assignee, label: updateTaskId?.assignee },
            Assigner:  { value: updateTaskId?.assigner, label: updateTaskId?.assigner },         
            activities: updateTaskId?.logs
        }))
        setOriginalTask((p) => ({
            ...p,
            StatusId: updateTaskId?.statusId,
            Status: updateTaskId?.status,
            subtask: updateTaskId?.subTasks,
            DueDate: updateTaskId?.dueDate,
            Priority: updateTaskId?.priority,
            Tags: updateTaskId?.tags,
            comments: updateTaskId?.comments,
            files: updateTaskId?.files,
            Assignee: { value: updateTaskId?.assignee, label: updateTaskId?.assignee },
            Assigner: { value: updateTaskId?.assigner, label: updateTaskId?.assigner },
            DueDate: updateTaskId?.dueDate ? updateTaskId.dueDate : "",
            activities: updateTaskId?.logs
        }))
        const safeJson = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        try {
        return JSON.parse(val);
        } catch {
        return [];
        }
        };

        setSelectLabs(safeJson(updateTaskId.labs))
        setSelectMeds(safeJson(updateTaskId.medications))
        setSelectImaging(safeJson(updateTaskId.imagings))
    }, [updateTaskId])

    useEffect(() => {
        if (!prmBoardId) return;

        const fetchBoard = async () => {
            const { data, error } = await supabase
                .from("boards")
                .select("*")
                .eq("id", prmBoardId)
                .single();
            console.log(data, error, 'fetching boarding')

            if (error) {
                toast.error("Failed to fetch board");
                console.error(error);
            } else {
                setBoardData(data);
            }
        };
        fetchBoard();

    }, [prmBoardId]);

    useEffect(() => {
        if (!boardData) return
        setTask((p) => ({
            ...p,
            StatusId: Array.isArray(boardData?.columns) && boardData?.columns.length > 0 && boardData?.columns[0].keyField,
            Status: Array.isArray(boardData?.columns) && boardData?.columns.length > 0 && boardData?.columns[0].headerText
        }))
        console.log(boardData?.columns, task, 'boardData?.columns')
    }, [boardData])

    const handleCreateTask = async () => {
        try {
              const missingFields = [];
                        
                                if (!title.trim()) missingFields.push("Title");
                                if (!description.trim()) missingFields.push("Description");
                                if (!task?.Status) missingFields.push("Status");
                                if (!task?.Priority) missingFields.push("Priority");
                                if (!task?.DueDate) missingFields.push("Due Date");
                              
                        
                                // If missing anything → one toast with all fields
                                if (missingFields.length > 0) {
                                    toast.error(
                                        `Please fill in the following fields:\n\n• ${missingFields.join("\n• ")}`,
                                        { autoClose: 4000 }
                                    );
                                    return;
                                }
               const changes = [];

            const cleanDate = (d) => formatValueToISODate(d);

            if (cleanDate(task.DueDate) !== cleanDate(originalTask?.DueDate)) {
                console.log('**date chaneg')
                changes.push(`Updated Due Date to ${task.DueDate}`);
            }

            if (task.Priority !== originalTask?.Priority) {
                changes.push(`Updated Priority to ${task.Priority}`);
            }

            if (task.Status !== originalTask?.Status) {
                changes.push(`Updated Status to ${task.Status}`);
            }

            if (task.Assignee?.label !== originalTask?.Assignee?.label) {
                changes.push(`Updated Assignee to ${task.Assignee?.label}`);
            }

            if (task.Assigner?.label !== originalTask?.Assigner?.label) {
                changes.push(`Updated Assigner to ${task.Assigner?.label}`);
            }

            let updatedActivities = Array.isArray(task.activities)
                ? [...task.activities]
                : [];

            if (changes.length > 0) {
                const newActivities = changes.map((c) => ({
                    Id: Date.now() + Math.random(),
                    Description: `${c} by ${loggedInUsername}`,
                    CreatedBy: loggedInUsername,
                    CreatedDate: new Date(),
                }));

                updatedActivities = [...updatedActivities, ...newActivities];
            }


            const taskPayload = {
                title,
                description,
                boardId: prmBoardId,
                status: task.Status,
                assignee: task?.Assignee?.label,
                assigneeId: "",
                assignerId: "",
                assigner: task?.Assigner?.label,
                priority: task.Priority,
                dueDate: task.DueDate || "",
                statusId: task.StatusId,
                comments: task.comments,
                files: task.files,
                subTasks: task.subtask,
                tags: task.Tags,
                medications: selectMeds,
                labs: selectLabs,
                imagings: selectImaging,
                logs: updatedActivities,
            };
 console.log('***',task, taskPayload)
            console.log(task, taskPayload)


            setLoading(true);

            const response = await SaveTasks('update', updateTaskId?.id, null, taskPayload);
            const { error } = response || {}

            setLoading(false);

            if (error) {
                toast.error("Failed to update task");
                console.error(error,"failed");
                return;
            }

            toast.success("Task update successfully");
            setVisible(false);
            setTitle("");
            setTask({
                Title: '',
                Status: '',
                DueDate: "",
                Summary: '',
                Type: 'Story',
                Priority: 'Low',
                Tags: [],
                subtask: [],
                Assignee: '',
                Color: '#02897B',
                comments: [],
                files: [],
                activities: [],
                Assigner: '',
                ClassName: 'e-story, e-low,',
            })
            setDescription("");

            setSelectImaging([])
            setSelectLabs([])
            setSelectMeds([])
            await fetchBoard()
        } catch (error) {
            console.log(error, 'error while updating')
        }
    };

    const [loggedInUsername, setLoggedInUsername] = useState('')

    const [task, setTask] = useState({
        Id: `${Date.now()}`,
        Title: '',
        StatusId: '',
        Status: 'To Do',
        DueDate: "",
        Summary: "",
        Type: 'Story',
        Priority: 'Low',
        Tags: [],
        comments: [],
        Assignee: [],
        // Assignee: users && users.length > 0 ? users[0]?.name : "",
        Color: '#02897B',
        files: [],
        subtask: [],
        Assigner: [],
        activities: [],
        ClassName: 'e-story, e-low,',
    })


    const getLoggedUsr = () => {
        try {
            const loggedUsrname = localStorage.getItem('userLoginWithCredentials')

            if (loggedUsrname) {
                const parsedUser = JSON.parse(loggedUsrname)
                console.log(parsedUser?.phoneNo, 'parsedUser?.phoneNo')
                // setTask((p) => ({
                //     ...p,
                //     Assigner: parsedUser?.phoneNo || '',
                // }))
                setLoggedInUsername(parsedUser?.phoneNo || '')
            }
        } catch (error) {
            console.error('Error parsing logged in user:', error)
        }
    }

    useEffect(() => {
        getLoggedUsr()
    }, [])


    const handleCloudinaryDelete = (id) => {
        setTask((p) => ({
            ...p,
            files: p.files ? p.files.filter((file) => file.id !== id) : [],
        }))
    }
    const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
        setTask((p) => ({
            ...p,
            files: [...(p.files || []), { url, type, fileName, id, publicId }],
        }))
    }

    const handleAddSubTask = (e) => {
        if (subtaskId !== null) {
            const updatedSubTask = task.subtask.map((subtsk) => {
                if (subtsk.id === subtaskId) {
                    return {
                        ...subtsk,
                        text: subTasks,
                    }
                }
                return subtsk
            })
            setTask({
                ...task,
                subtask: updatedSubTask,
            })
            setSubTasks('')
            setSubTaskId(null)

            // setTempActivities((prev) => {
            //     const newDesc = 'Updated the subtask by' + loggedInUsername

            //     const exists = prev.some((a) => a.Description === newDesc)

            //     if (exists) return prev

            //     return [
            //         ...prev,
            //         {
            //             Id: Date.now(),
            //             Description: newDesc,
            //             CreatedBy: loggedInUsername,
            //             CreatedDate: new Date(),
            //         },
            //     ]
            // })
        } else {
            e.preventDefault()
            if (subTasks.trim !== '') {
                setTask((p) => ({
                    ...p,
                    subtask: [
                        ...(p.subtask || []),
                        {
                            id: Date.now(),
                            text: subTasks,
                            createdAt: new Date(),
                            isCompleted: false,
                            checkedBy: '',
                            createdBy: loggedInUsername,
                        },
                    ],
                }))
                setSubTasks('')
                // setTempActivities((prev) => {
                //     const newDesc = 'New subtask added by ' + loggedInUsername

                //     const exists = prev.some((a) => a.Description === newDesc)

                //     if (exists) return prev

                //     return [
                //         ...prev,
                //         {
                //             Id: Date.now(),
                //             Description: newDesc,
                //             CreatedBy: loggedInUsername,
                //             CreatedDate: new Date(),
                //         },
                //     ]
                // })
            }
        }
    }

    const handleChangeComment = (e) => {
        setComment(e.target.value)

        // setTempActivities((prev) => {
        //     const newDesc = 'Added the comment by ' + loggedInUsername

        //     const exists = prev.some((a) => a.Description === newDesc)

        //     if (exists) return prev

        //     return [
        //         ...prev,
        //         {
        //             Id: Date.now(),
        //             Description: newDesc,
        //             CreatedBy: loggedInUsername,
        //             CreatedDate: new Date(),
        //         },
        //     ]
        // })
    }

    const handleAddComment = (e) => {
        if (!comment) {
            toast.error('Please enter comment', toastConfig)
            return
        }
        if (commentEditId !== null) {
            const updatedComments = task.comments.map((cmnt) => {
                if (cmnt.id === commentEditId) {
                    return {
                        ...cmnt,
                        text: comment,
                    }
                }
                return cmnt
            })
            setTask({
                ...task,
                comments: updatedComments,
            })
            setComment('')
            setCommentEditId(null)
        } else {
            e.preventDefault()
            if (comment.trim !== '') {
                setTask((p) => ({
                    ...p,
                    comments: [
                        ...(p.comments || []),
                        {
                            id: Date.now(),
                            text: comment,
                            createdAt: new Date(),
                            createdBy: loggedInUsername,
                        },
                    ],
                }))
                setComment('')
            }
        }
    }

      const handleDateChange = (val) => {
    setTask(prev => ({
        ...prev,
        DueDate: val
    }));

    // setTempActivities(prev => {
    //     const newDesc = "Updated the due date by " + loggedInUsername;

    //     if (prev.some(a => a.Description === newDesc)) return prev;

    //       return [
    //             ...prev,
    //             {
    //                 Id: Date.now(),
    //                 Description: newDesc,
    //                 CreatedBy: loggedInUsername,
    //                 CreatedDate: new Date(),
    //             },
    //         ]
    //     })
    }
    // const handleChange = (e) => {
    //     const { name, value } = e.target
    //     setTask({ ...task, [name]: value })
    //     setTempActivities((prev) => {
    //         const newDesc = 'Updated the due date by ' + loggedInUsername

    //         const exists = prev.some((a) => a.Description === newDesc)

    //         if (exists) return prev

    //         return [
    //             ...prev,
    //             {
    //                 Id: Date.now(),
    //                 Description: newDesc,
    //                 CreatedBy: loggedInUsername,
    //                 CreatedDate: new Date(),
    //             },
    //         ]
    //     })
    // }

    const [users, setUsers] = useState([])

    console.log(users, 'users')

    const GetAllUsers = async () => {
        const response = await RegisterUser('', '', '', '', 'get_all')
        let allUsers = response?.d
        allUsers = allUsers.Users
        console.log(allUsers, 'allUsers')
        if (allUsers.length > 0) {
            setUsers(
                allUsers.map((item) => {
                    return {
                        name: item.Username,
                        label: item.Username,
                        role: 'office',
                    }
                }),
            )
        }
    }

    useEffect(() => {
        GetAllUsers()
    }, [])

    const priorityOptions = [
        { value: 'Low', label: 'Low' },
        { value: 'Medium', label: 'Medium' },
        { value: 'High', label: 'High' },
    ]

    const [textInput, setTextInput] = useState('')

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && textInput.trim()) {
            event.preventDefault()
            const newKeyword = textInput.trim()
            setTask((p) => ({
                ...p,
                Tags: [...p.Tags, newKeyword],
            }))
            setTextInput('')
            // setTempActivities((prev) => {
            //     const newDesc = 'Updated the tags by ' + loggedInUsername

            //     const exists = prev.some((a) => a.Description === newDesc)

            //     if (exists) return prev

            //     return [
            //         ...prev,
            //         {
            //             Id: Date.now(),
            //             Description: newDesc,
            //             CreatedBy: loggedInUsername,
            //             CreatedDate: new Date(),
            //         },
            //     ]
            // })
        }
    }

    // Parents Labs,imagigng,medications
    const [imagingTypeList, setImagingTypeList] = useState([])
    const [masterMedications, setMasterMedications] = useState([])
    const [masterLabs, setMasterLabs] = useState([])
    const getImagingData = async () => {
        try {
            const data = await ImagingInformation('GET_ALL')
            if (data) {
                const formattedData = JSON.parse(data.d)?.Data
                const allFormattedData = formattedData
                    .filter((item) => item.Keywords !== '')
                    .map((item) => {
                        return {
                            value: item.ID,
                            label: item.Name
                        }
                    })
                console.log(allFormattedData, 'allFormattedData')
                setImagingTypeList(allFormattedData)
            }
        } catch (error) {
            console.error('Error fetching imaging data', error)
        }
    }

    const GetMasterMedications = async () => {
        try {
            let allMedicines = await MedicineCRUD('GET')
            let formattedData = JSON.parse(allMedicines.d)?.Data
            if (formattedData) {
                formattedData = formattedData.map((item) => {
                    let itemData = JSON.parse(item.Data)
                    return {
                        value: item.ID,
                        label: itemData.name,
                    }
                })
                setMasterMedications(formattedData)
            }
        } catch (error) {
            console.error('Error fetching master medications:', error)
        }
    }


    const getLabData = async () => {
        console.log('labs running')
        try {
            let labData = await LabCRUD("GETALL", "{}");
            labData = JSON.parse(labData.d)?.Data;

            if (labData.length > 0) {
                let option = labData?.map((item) => (
                    {
                        value: item.ID,
                        label: item.LabName,
                    }
                ))
                console.log(option, 'option')
                setMasterLabs(option);
            }
        } catch (error) {
            console.log(error, 'error')
        }
    };
    useEffect(() => {
        getImagingData()
        GetMasterMedications()
        getLabData()
    }, [])

    return (
        <div className="">

            <CModal
                className="task-jira-modal"
                backdrop="static" scrollable size="xl"
                visible={visible}
                onClose={() => setVisible(false)}
            >
                <CModalHeader
                className="text-white"
                style={{
                        backgroundColor: '#191919',
                        borderBottom: '1px solid gray',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        borderRadius: '10px 10px 0 0',
                    }}
                >
                    <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        Update Task
                        {/* {boardData && `• ${boardData.title}`} */}
                    </CModalTitle>
                </CModalHeader>

                <CModalBody
                style={{
                    backgroundColor: 'var(--ui-bg-modal-body)',
                    color: 'white',
                }}
                >
                    <div className="d-flex flex-column flex-md-row gap-4">
                        <div
                            style={{
                                width: isMobile ? "" : '70%',
                            }}
                            className="d-flex flex-column gap-3">
                            <div>
                                <CFormLabel>Title<span style={{ color: "red", marginLeft: '4px' }}>*</span></CFormLabel>
                                <CFormInput
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Task title"
                                    style={{
                                        border: "0",
                                        background: "#8080800d",
                                        color:'white'
                                    }}
                                />
                            </div>

                            <div>
                                <CFormLabel>Description<span style={{ color: "red", marginLeft: '4px' }}>*</span></CFormLabel>
                                <CFormTextarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Task description"
                                    style={{
                                        height: "150px",
                                        border: "0",
                                        background: "#8080800d",
                                         color:'white'
                                    }}
                                />
                            </div>

                            <div
                                className="d-flex flex-column gap-2"
                            >
                                <span className="" style={{ width: '' }}>
                                    <CFormLabel>Select Labs</CFormLabel>
                                    <Select
                                    styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                                        placeholder="Select Labs"
                                        name="Status"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        onChange={setSelectLabs}
                                        value={selectLabs}
                                        options={masterLabs}
                                    />
                                </span>
                                <span className="" style={{ width: '' }}>
                                    <CFormLabel>Select Medications</CFormLabel>
                                    <Select
                                    styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                                        placeholder="Select Medications"
                                        name="Status"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        onChange={setSelectMeds}
                                        value={selectMeds}
                                        // options={masterLabs}
                                       options={masterMedications}
                                    />
                                </span>
                                <span className="" style={{ width: '' }}>
                                    <CFormLabel>Select Imagings</CFormLabel>
                                    <Select
                                    styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                                        placeholder="Select Imaging"
                                        name="Status"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        onChange={setSelectImaging}
                                        value={selectImaging}
                                        options={imagingTypeList}
                                    />
                                </span>
                            </div>

                            <div className="d-fl gap-2">
                                <CloudinaryUploader acceptedFileTypes='image/*,' filesAl={task?.files} onDelete={handleCloudinaryDelete} onUploadSuccess={handleCloudinaryUpload} />

                                <div className="d-flex mt-2 align-items-center gap-2 flex-wrap">
                                    {task.files.length > 0 &&
                                        task.files?.map((file, idx) => {
                                            return (
                                                <div key={idx} className="d-flex flex-column align-items-center">
                                                    <img
                                                        src={file.url}
                                                        alt="Preview"
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            borderRadius: '4px',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
                            <CNav
                            style={{
                                    placeContent: 'center!important',
                                    display: 'grid!important',
                                    gridTemplateColumns: '1fr 1fr 1fr',
                                    background: '#191919'
                                }}
                                className="d-grid task-tabs place-content-center  nav-custom-gray-tabs m-0 align-items-center justify-content-center"
                                variant="pills"
                                role="tablist"
                            >
                                <CNavItem
                                    className=""
                                    style={{
                                        width: '33.33%!important',
                                    }}
                                >
                                    <CNavLink
                                        className=""
                                        style={{
                                            fontSize: '13px',
                                        }}
                                        active={activeKey === 3}
                                        onClick={() => setActiveKey(3)}
                                    >
                                        Subtasks
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem
                                    style={{
                                        width: '33.33%!important',
                                    }}
                                >
                                    <CNavLink
                                        className=""
                                        style={{
                                            fontSize: '13px',
                                            width: '100%',
                                        }}
                                        active={activeKey === 1}
                                        onClick={() => setActiveKey(1)}
                                    >
                                        Comments
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem
                                    style={{
                                        width: '33.33%!important',
                                    }}
                                >
                                    <CNavLink
                                        className=""
                                        style={{
                                            fontSize: '13px',
                                            width: '100%',
                                        }}
                                        active={activeKey === 2}
                                        onClick={() => setActiveKey(2)}
                                    >
                                        Logs
                                    </CNavLink>
                                </CNavItem>
                            </CNav>

                            {activeKey === 1 && (
                                <div className="d-flex gap-2 flex-column">
                                    {/* Comments */}
                                    <div className="d-flex flex-column align-items-start gap-2">
                                        <CFormLabel>Add Comments</CFormLabel>
                                        <CFormTextarea aria-rowcount={12}  style={{ height: '100px' ,  background: "#8080800d" , color:'white'}}  placeholder="Comments" value={comment} onChange={handleChangeComment} />
                                        <CButton disabled={!comment} onClick={handleAddComment}>
                                            {commentEditId !== null ? 'Edit' : 'Add'}
                                        </CButton>
                                    </div>

                                    <div>
                                        {task?.comments?.map((item, idx) => {
                                            return (
                                                <div className="d- gap-2">
                                                    <CCard style={{ height: '100px' ,  background: "#8080800d" , color:'white'}} >
                                                        <CCardBody className="d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <CCardTitle style={{ fontSize: '18px' , color:'white' }}>{item.text}</CCardTitle>
                                                                <CCardText>Created by : {item.createdBy || '-'}</CCardText>
                                                            </div>
                                                            <span className="d-flex align-items-center gap-2">
                                                                {loggedInUsername && item.createdBy === loggedInUsername && (
                                                                    <CButton
                                                                        onClick={() => {
                                                                            setCommentEditId(item.id)
                                                                            setComment(item.text)
                                                                        }}
                                                                        variant="outline"
                                                                        color="primary"
                                                                    >
                                                                        {' '}
                                                                        <Pencil size={15} />
                                                                    </CButton>
                                                                )}
                                                                {loggedInUsername && item.createdBy === loggedInUsername && (
                                                                    <CButton
                                                                        onClick={() => {
                                                                            const filteredTasks = task.comments.filter((c) => c.id !== item.id)
                                                                            setTask((prevState) => ({
                                                                                ...prevState,
                                                                                comments: filteredTasks,
                                                                            }))
                                                                        }}
                                                                        variant="outline"
                                                                        color="danger"
                                                                    >
                                                                        {' '}
                                                                        <Trash size={15} />
                                                                    </CButton>
                                                                )}
                                                            </span>
                                                        </CCardBody>
                                                    </CCard>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )}

                            <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeKey === 3}>
                                {activeKey === 3 && (
                                    <div className="d-flex gap-2 flex-column">
                                        {/* Comments */}
                                        <div className="d-flex flex-column align-items-start gap-2">
                                            {/* <CFormLabel>Add Subtask</CFormLabel>
                                                                <CFormTextarea aria-rowcount={12} style={{ height: "100px" }} placeholder="Add Subtask" value={subTasks} onChange={handleSubTaskChange} /> */}
                                            <CButton variant="outline" onClick={handleAddSubTask}>
                                                {subtaskId !== null ? 'Edit' : 'Add Subtask'}
                                            </CButton>
                                        </div>

                                        <div
                                            style={{
                                                 maxHeight: '368px',
                                                 minHeight: '200px',
                                                 overflow: 'none',
                                            
                                            }}
                                        >
                                            {task?.subtask?.map((item, idx) => {
                                                return (
                                                    <div className="gap-2">
                                                        <CCard className="" style={{background:'#191919'}}>
                                                            <CCardBody className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex w-100 align-items-center gap-3">
                                                                    <CFormCheck
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                        }}
                                                                        className=""
                                                                        disabled={item.isCompleted}
                                                                        checked={item.isCompleted}
                                                                        onClick={() => {
                                                                            if (item.isCompleted) return
                                                                            setTask((prevState) => ({
                                                                                ...prevState,
                                                                                subtask: prevState.subtask.map((subTask) =>
                                                                                    subTask.id === item.id
                                                                                        ? {
                                                                                            ...subTask,
                                                                                            isCompleted: !subTask.isCompleted,
                                                                                            checkedBy: loggedInUsername || '',
                                                                                        }
                                                                                        : subTask,
                                                                                ),
                                                                            }))
                                                                        }}
                                                                    />
                                                                    <input
                                                                        disabled={loggedInUsername && item.createdBy !== loggedInUsername}
                                                                        onChange={(e) => {
                                                                            setTask((p) => ({
                                                                                ...p,
                                                                                subtask: p.subtask.map((subTask) =>
                                                                                    subTask.id === item.id
                                                                                        ? {
                                                                                            ...subTask,
                                                                                            text: e.target.value,
                                                                                        }
                                                                                        : subTask,
                                                                                ),
                                                                            }))
                                                                        }}
                                                                        placeholder="Enter Subtask.."
                                                                        style={{
                                                                            padding: '10px 15px',
                                                                            width: '100%',
                                                                            height: '40px',
                                                                            border: '0',
                                                                            background: '#8080800d',
                                                                        }}
                                                                        className=" mb-0 ml-4"
                                                                        value={item.text}
                                                                    />
                                                                </div>
                                                                {/* {item.isCompleted && <span class="badge text-bg-primary">Task completed by {item.checkedBy}</span>} */}

                                                                <div
                                                                    className="l-4"
                                                                    style={{
                                                                        paddingLeft: '20px',
                                                                    }}
                                                                >
                                                                    <CDropdown alignment={'end'} >
                                                                        <CDropdownToggle variant="outline"  color="primary">
                                                                            <EllipsisVertical />
                                                                        </CDropdownToggle>
                                                                        <CDropdownMenu  style={{ backgroundColor: '#282828', color: 'white' }}> 
                                                                            <CDropdownItem >Created By : {item.createdBy}</CDropdownItem>
                                                                            <CDropdownItem >Created At : {new Date(item.id).toDateString()}</CDropdownItem>
                                                                            {item.isCompleted && <CDropdownItem>Completed By : {item.checkedBy}</CDropdownItem>}
                                                                            {/* {loggedInUsername && item.createdBy === loggedInUsername && <CDropdownItem
                                                                                                    style={{
                                                                                                        color: "red"
                                                                                                    }}
                                                                                                    onClick={() => {
                                                                                                        setSubTaskId(item.id)
                                                                                                        setSubTasks(item.text)
                                                                                                    }}
                                                                                                >
                                                                                                    Edit
                                                                                                </CDropdownItem>} */}
                                                                            {loggedInUsername && item.createdBy === loggedInUsername && (
                                                                                <CDropdownItem
                                                                                    style={{
                                                                                        color: 'red',
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        const filteredTasks = task.subtask.filter((c) => c.id !== item.id)
                                                                                        setTask((prevState) => ({
                                                                                            ...prevState,
                                                                                            subtask: filteredTasks,
                                                                                        }))
                                                                                        // setTempActivities((prev) => {
                                                                                        //     const newDesc = 'Deleted the subtask by ' + loggedInUsername

                                                                                        //     const exists = prev.some((a) => a.Description === newDesc)

                                                                                        //     if (exists) return prev

                                                                                        //     return [
                                                                                        //         ...prev,
                                                                                        //         {
                                                                                        //             Id: Date.now(),
                                                                                        //             Description: newDesc,
                                                                                        //             CreatedBy: loggedInUsername,
                                                                                        //             CreatedDate: new Date(),
                                                                                        //         },
                                                                                        //     ]
                                                                                        // })
                                                                                    }}
                                                                                >
                                                                                    Delete
                                                                                </CDropdownItem>
                                                                            )}
                                                                        </CDropdownMenu>
                                                                    </CDropdown>
                                                                </div>
                                                            </CCardBody>
                                                        </CCard>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            </CTabPane>

                            <CTabPane
                                style={{
                                    overflow: 'hidden',
                                    overflowY: 'auto',
                                }}
                                role="tabpanel"
                                aria-labelledby="home-tab"
                                visible={activeKey === 2}
                            >
                                {activeKey === 2 && (
                                    <div>
                                        {task?.activities.map((item, idx) => {
                                            return (
                                                <div
                                                    className="d- gap-2 p-4 border mb-2"
                                                    key={idx}
                                                    style={{
                                                        borderRadius: '8px',
                                                    }}
                                                >
                                                    <div className="d-flex flex-column gap-2">
                                                        {/* <p className='m-0' style={{
                                                                                            fontWeight:"bold"
                                                                                        }}>Activity #{idx + 1}</p> */}
                                                        <p
                                                            className="m-0"
                                                            style={{
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {item.Description}
                                                        </p>
                                                        <div className="d-flex gap-2">
                                                            <p
                                                                className="m-0"
                                                                style={{
                                                                    fontWeight: 600,
                                                                    color: 'gray',
                                                                }}
                                                            >
                                                                By : {item.CreatedBy}
                                                            </p>
                                                            <p
                                                                className="m-0"
                                                                style={{
                                                                    fontWeight: 600,
                                                                    color: 'gray',
                                                                }}
                                                            >
                                                                {item.CreatedDate
                                                                    ? new Date(item.CreatedDate)
                                                                        .toLocaleString('en-US', {
                                                                            day: '2-digit',
                                                                            month: '2-digit',
                                                                            year: 'numeric',
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            hour12: true,
                                                                        })
                                                                        .replace(',', ' at')
                                                                    : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </CTabPane>

                        </div>
                        <div
                            style={{
                                width: isMobile ? "" : '30%',
                                borderRadius: '20px',
                                border: '1px solid var(--task-jira-modal-border, var(--ui-dashboard-border-strong))',
                                padding: '20px',
                            }}
                            className=" d-flex align-items- gap-2 flex-column"
                        >
                            {/* <span className="">
                                <CFormLabel>Assign By</CFormLabel>
                                <CFormInput  style={{background:'#191919 ' , color:'gray'}} placeholder="Assign By"  name="Assigner" value={task.Assigner} onChange={handleChange} />
                            </span> */}

                             <div>
                                                            <CFormLabel>Assigned By</CFormLabel>
                                                            <Select
                                                                placeholder="Select Assigner"
                                                                name="Assigner"
                                                                options={users.map(({ label, name }) => ({ value: label, label: name }))}
                                                                 styles={{
                                                          control: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: '#191919',
                                                            borderColor: state.isFocused ? '#444' : '#444',
                                                            borderRadius: '6px',
                                                            boxShadow: 'none',
                                                            '&:hover': {
                                                              borderColor: '#444',
                                                            },
                                                          }),
                                                          menu: (base) => ({
                                                            ...base,
                                                            backgroundColor: '#000',
                                                            borderRadius: '6px',
                                                          }),
                                                          option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected
                                                              ? '#191919' // blue for selected
                                                              : state.isFocused
                                                              ? '#2a2a2a'
                                                              : '#000',
                                                            color: 'white',
                                                            cursor: 'pointer',
                                                            padding: '12px 14px',
                                                            borderBottom: '1px solid #333',
                                                            ':last-of-type': {
                                                              borderBottom: 'none',
                                                            },
                                                            ':active': {
                                                              backgroundColor: '#2a2a2a',
                                                            },
                                                          }),
                                                          multiValue: (base) => ({
                                                            ...base,
                                                            backgroundColor: '#191919',
                                                            borderRadius: '4px',
                                                            border: '1px solid #454545ff',
                                                          }),
                                                          multiValueLabel: (base) => ({
                                                            ...base,
                                                            color: 'white',
                                                          }),
                                                          multiValueRemove: (base) => ({
                                                            ...base,
                                                            color: 'white',
                                                            ':hover': {
                                                              backgroundColor: '#333',
                                                              color: 'white',
                                                            },
                                                          }),
                                                          singleValue: (base) => ({
                                                            ...base,
                                                            color: 'white',
                                                          }),
                                                          placeholder: (base) => ({
                                                            ...base,
                                                            color: '#aaa',
                                                          }),
                            
                                                          input: (base) => ({
                                                            ...base,
                                                            color: 'white',
                                                          }),
                                                          dropdownIndicator: (base) => ({
                                                            ...base,
                                                            color: 'white',
                                                            ':hover': { color: 'white' },
                                                          }),
                                                        }}
                                                                // value={task.Assignee ? { value: task.Assignee, label: task.Assignee } : null}
                                                                // onChange={(selectedOptions) => {
                                                                //     setTask((prevState) => ({
                                                                //         ...prevState,
                                                                //         Assignee: selectedOptions.value,
                                                                //     }));
                                                                // }}
                                                                value={task?.Assigner || []}
                                                                onChange={(selectedOptions) => {
                                                                    setTask((prevState) => ({
                                                                        ...prevState,
                                                                        Assigner: selectedOptions,
                                                                    }))
                            
                                                                    // setTempActivities((prev) => {
                                                                    //     const newDesc = 'Updated the Assigner to ' + loggedInUsername
                            
                                                                    //     const exists = prev.some((a) => a.Description === newDesc)
                            
                                                                    //     if (exists) return prev
                            
                                                                    //     return [
                                                                    //         ...prev,
                                                                    //         {
                                                                    //             Id: Date.now(),
                                                                    //             Description: newDesc,
                                                                    //             CreatedBy: loggedInUsername,
                                                                    //             CreatedDate: new Date(),
                                                                    //         },
                                                                    //     ]
                                                                    // })
                                                                }}
                                                            />
                                                        </div>
                            <span className="" style={{ width: '' }}>
                                <CFormLabel>Status<span style={{ color: "red", marginLeft: '4px' }}>*</span></CFormLabel>
                                <Select
                                styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                                    placeholder="Select Status"
                                    name="Status"
                                    defaultValue={{ value: boardData?.columns[0].keyField, label: boardData?.columns[0].headerText }}
                                    options={boardData?.columns?.map((item) => ({ value: item.keyField, label: item.headerText })) || []}
                                    value={boardData?.columns?.find((option) => option.keyField === task.StatusId) ? { value: task.StatusId, label: task.Status } : boardData?.columns?.length ? { value: boardData.columns[0].keyField, label: boardData.columns[0].headerText } : null}
                                    onChange={(selectedOption) => {
                                        console.log(selectedOption, 'selectedOption')
                                        setTask((prevState) => ({
                                            ...prevState,
                                            Status: selectedOption?.label || null,
                                            StatusId: selectedOption?.value
                                        }))

                                        // setTempActivities((prev) => {
                                        //     const newDesc = 'Updated the task status by ' + loggedInUsername
                                        //     const exists = prev.some((a) => a.Description === newDesc)
                                        //     if (exists) return prev
                                        //     return [
                                        //         ...prev,
                                        //         {
                                        //             Id: Date.now(),
                                        //             Description: newDesc,
                                        //             CreatedBy: loggedInUsername,
                                        //             CreatedDate: new Date(),
                                        //         },
                                        //     ]
                                        // })
                                    }}
                                />
                            </span>
                            <div>
                                <CFormLabel>Assigned To</CFormLabel>
                                <Select
                                styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                                  
                                    placeholder="Select users to assign"
                                    name="openTo"
                                    options={users.map(({ label, name }) => ({ value: label, label: name }))}
                                    // value={task.Assignee ? { value: task.Assignee, label: task.Assignee } : null}
                                    // onChange={(selectedOptions) => {
                                    //     setTask((prevState) => ({
                                    //         ...prevState,
                                    //         Assignee: selectedOptions.value,
                                    //     }));
                                    // }}
                                    value={task?.Assignee || []}
                                    onChange={(selectedOptions) => {
                                        setTask((prevState) => ({
                                            ...prevState,
                                            Assignee: selectedOptions,
                                        }))

                                        // setTempActivities((prev) => {
                                        //     const newDesc = 'Updated the assignee by ' + loggedInUsername

                                        //     const exists = prev.some((a) => a.Description === newDesc)

                                        //     if (exists) return prev

                                        //     return [
                                        //         ...prev,
                                        //         {
                                        //             Id: Date.now(),
                                        //             Description: newDesc,
                                        //             CreatedBy: loggedInUsername,
                                        //             CreatedDate: new Date(),
                                        //         },
                                        //     ]
                                        // })
                                    }}
                                />
                            </div>
                            {/* <span className=''>
                                                <CFormLabel>Assign To</CFormLabel>
                                                <CFormInput placeholder="Assign To" name="Assignee" value={task.Assignee} onChange={handleChange} />
                                            </span> */}
                            <span className="">
                                <CFormLabel>Due Date<span style={{ color: "red", marginLeft: '4px' }}>*</span></CFormLabel>
                                 <CustomDatePickingFormat
                                    color="primary"
                                    value={task.DueDate}
                                    name="DueDate"
                                    onChange={(val) => handleDateChange(val)}
                                    //  onChange={(e) => console.log("DATE PICKER VALUE:", e)}
                                    aria-describedby="exampleFormControlInputHelpInline"/>
                                {/* <CFormInput style={{background:'#191919' , color: 'white'}} type="datetime-local" placeholder="Due Date" name="DueDate" value={task.DueDate} onChange={handleChange} /> */}
                            </span>

                            <span className="">
                                <CFormLabel>Set Priority<span style={{ color: "red", marginLeft: '4px' }}>*</span></CFormLabel>
                                <Select

                                styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                                    options={priorityOptions}
                                    value={priorityOptions.find((option) => option.value === task?.Priority) || null}
                                    onChange={(selectedOption) => {
                                        setTask((prevState) => ({
                                            ...prevState,
                                            Priority: selectedOption?.value || '',
                                        }))

                                        // setTempActivities((prev) => {
                                        //     const newDesc = 'Updated the priority by ' + loggedInUsername

                                        //     const exists = prev.some((a) => a.Description === newDesc)

                                        //     if (exists) return prev

                                        //     return [
                                        //         ...prev,
                                        //         {
                                        //             Id: Date.now(),
                                        //             Description: newDesc,
                                        //             CreatedBy: loggedInUsername,
                                        //             CreatedDate: new Date(),
                                        //         },
                                        //     ]
                                        // })
                                    }}
                                />
                            </span>

                            <span className="">
                                <CFormLabel>Tags</CFormLabel>
                                <CFormTextarea
                                style={{background:'#191919' , color: 'white'}} 
                                    type="text"
                                    placeholder={'Type and press enter to add '}
                                    value={textInput}
                                    onChange={(e) => {
                                        setTextInput(e.target.value)
                                    }}
                                    onKeyPress={handleKeyPress}
                                    name="assessment"
                                    rows={1}
                                />
                                <div style={{ marginTop: '10px', cursor: 'pointer' }} className="d-flex align-items-center flex-wrap gap-1">
                                    {task.Tags &&
                                        task.Tags.map((tag, idx) => (
                                            <CBadge key={idx} className="task-jira-tag-pill d-flex align-items-center gap-2 me-2 mr-1 mb-1" style={{ cursor: 'pointer', width: 'fit-content', textOverflow: "clip", whiteSpace: "nowrap" }}>
                                                <span style={{ maxWidth: '100px', overflowX: "auto", textOverflow: "clip", whiteSpace: "nowrap" }}> {tag.trim()}</span>
                                                <X
                                                    onClick={() => {
                                                        const fil = task.Tags.filter((tg, i) => i !== idx)
                                                        setTask((p) => ({
                                                            ...p,
                                                            Tags: fil,
                                                        }))
                                                    }}
                                                    size={15}
                                                />
                                            </CBadge>
                                        ))}
                                </div>
                            </span>
                        </div>
                    </div>
                </CModalBody>

                <CModalFooter
                    style={{
                        backgroundColor: '#191919',
                        borderTop: '1px solid gray',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '10px',
                        borderRadius: '0 0 10px 10px',
                    }}
                >
                    <CButton
                        variant="outline"
                        color="secondary"
                        onClick={() => {
                            setVisible(false)
                           
                            // setTitle('');
                            // setDescription('');
                            // setTask({
                            //     Title: '',
                            //     Status: '',
                            //     DueDate: "",
                            //     Summary: '',
                            //     Type: 'Story',
                            //     Priority: 'Low',
                            //     Tags: [],
                            //     subtask: [],
                            //     Assignee: '',
                            //     Color: '#02897B',
                            //     comments: [],
                            //     files: [],
                            //     activities: [],
                            //     Assigner: '',
                            //     ClassName: 'e-story, e-low,',
                            // })
                            

                            // setSelectImaging([])
                            // setSelectLabs([])
                            // setSelectMeds([])
                        }}
                    >
                        Close
                    </CButton>

                    <CButton
                        color="primary"
                        // disabled={loading || !title.trim() || !description.trim() || !task?.Status || !task?.Priority || !task?.DueDate || !task?.StatusId}
                        onClick={handleCreateTask}
                    >
                        {loading ? "Updating..." : "Update Task"}
                    </CButton>
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default ProviderUpdateTask;
